import { useEffect, useState } from 'react';
import { useSearchParams } from 'next/navigation';
import { useAuthenticatedSWR } from '../api';
import {
  LEGACY_OFFER_URL,
  OFFER_URL,
  REACTIVATION_CODE_TYPE,
} from './constants';
import { getFormattedOfferAmountByType } from './helpers';

export const useMxDiscount = (isLegacy = false) => {
  const [queryOfferCode, setQueryOfferCode] = useState(null);
  const [invalidQueryCodes, setInvalidQueryCodes] = useState([]);
  const searchParams = useSearchParams();

  useEffect(() => {
    const offerCodeParam = searchParams?.get('offer_code');

    if (offerCodeParam) {
      setQueryOfferCode(offerCodeParam);
    }
  }, [searchParams]);

  const codeMightBeValid =
    !!queryOfferCode && !invalidQueryCodes.includes(queryOfferCode);

  const { data, error } = useAuthenticatedSWR(
    queryOfferCode
      ? `${isLegacy ? LEGACY_OFFER_URL : OFFER_URL}${queryOfferCode}/`
      : null,
  );

  useEffect(() => {
    if (codeMightBeValid && error) {
      setInvalidQueryCodes(prevCodes => [...prevCodes, queryOfferCode]);
      setQueryOfferCode(null);
    }
  }, [codeMightBeValid, error, queryOfferCode]);

  const dataCompleteWithCode = data?.code
    ? data
    : { ...data, code: queryOfferCode };
  const isReactivationType = isLegacy
    ? dataCompleteWithCode?.category === REACTIVATION_CODE_TYPE
    : dataCompleteWithCode?.code?.indexOf('_RA') > -1;

  return {
    loading: queryOfferCode ? !data && !error : false,
    data: {
      ...dataCompleteWithCode,
      isReactivationType,
      formattedAmount: getFormattedOfferAmountByType(dataCompleteWithCode),
    },
    invalidQueryCodes,
  };
};
